import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/** Formata número em BRL a partir de centavos. */
export function formatBRL(cents: number | null | undefined): string {
  if (cents == null) return '—';
  return (cents / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

/** Formata data ISO como "08/04/2026". */
export function formatDate(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const date = typeof iso === 'string' ? parseISO(iso) : iso;
  return format(date, 'dd/MM/yyyy', { locale: ptBR });
}

/** Formata data+hora como "08/04/2026 20:30". */
export function formatDateTime(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const date = typeof iso === 'string' ? parseISO(iso) : iso;
  return format(date, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
}

/** "há 2 horas", "em 3 dias". */
export function formatRelative(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const date = typeof iso === 'string' ? parseISO(iso) : iso;
  return formatDistanceToNowStrict(date, { locale: ptBR, addSuffix: true });
}

/** Formata CNPJ em XX.XXX.XXX/XXXX-XX a partir de string já formatada ou de 14 dígitos. */
export function formatCNPJ(value: string | null | undefined): string {
  if (!value) return '—';
  const digits = value.replace(/\D/g, '');
  if (digits.length !== 14) return value;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(
    8,
    12,
  )}-${digits.slice(12)}`;
}

/** Inicial(ais) para avatar. */
export function initialsFromName(name: string | null | undefined): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0]}${parts[parts.length - 1]![0]}`.toUpperCase();
}
